"use client"
import React from "react"
import LoomFooter from "./Footer"
import { Header } from "@/shared/components/Header"
import { Analytics } from "@abraxas/ui/analytics"
import { Toaster } from "@abraxas/ui/ui"

const PublicLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="md:flex text-white">
      <Analytics />
      <Toaster />
      <div className="min-h-screen max-w-screen flex-grow flex flex-col">
        <Header />
        <main className="text-white grow">{children}</main>
        <LoomFooter />
      </div>
      <div id="drawer-root" className="contents" />
    </div>
  )
}

export default PublicLayout
